
import { Component, Prop, Vue } from 'vue-property-decorator';
import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { schedule9DataInfoType } from '@/types/Application/FamilyLawMatter/Pdf';

@Component({
    components:{
        UnderlineForm,
        CheckBox
    }
})

export default class Schedule19 extends Vue {

    @Prop({required:true})
    result!: any;
  
    dataReady = false;
    spsSupInfo = {} as schedule9DataInfoType;    
   
    mounted(){
        this.dataReady = false;        
        this.extractInfo();       
        this.dataReady = true;        
    } 

    public extractInfo(){
        this.spsSupInfo = this.getNewSpousalSupportInfo();
    }

    public getNewSpousalSupportInfo(){

        let newSpousalSupportInfo = {} as schedule9DataInfoType;
       
        if (this.result.spousalSupportSurvey){
            const entitlementReasons = this.result.spousalSupportSurvey.listOfReasons? this.result.spousalSupportSurvey.listOfReasons:[]
            if(entitlementReasons){
                newSpousalSupportInfo.current = {
                    adv: entitlementReasons.includes('There are economic advantages or disadvantages to the spouses arising from the relationship or breakdown of the relationship'),
                    share: entitlementReasons.includes('To share the financial consequences arising from caring for the children during the relationship, beyond the duty to provide support for the child'),
                    hardship: entitlementReasons.includes('To relieve economic hardship of the spouses arising from the breakdown of the relationship'),
                    bcmIndpndnt: entitlementReasons.includes('To help each spouse become financially independent within a reasonable period'),
                    crntArrngmnt: (this.result.spousalSupportSurvey.currentSupport)? this.result.spousalSupportSurvey.currentSupport:'',
                    payors: (this.result.spousalSupportSurvey.listOfSupportPayors 
                            && this.result.spousalSupportSurvey.listOfSupportPayors.length > 0)? this.result.spousalSupportSurvey.listOfSupportPayors:''
                }
            } else{
                newSpousalSupportInfo.current = {
                    adv: false,
                    share: false,
                    hardship: false,
                    bcmIndpndnt: false,
                    crntArrngmnt: (this.result.spousalSupportSurvey.currentSupport)? this.result.spousalSupportSurvey.currentSupport:'',
                    payors: (this.result.spousalSupportSurvey?.listOfSupportPayors?.length > 0)? this.result.spousalSupportSurvey.listOfSupportPayors:''
                }
            }

        }

        if (this.result.spousalSupportIncomeAndEarningPotentialSurvey){
            const incomeEarning = this.result.spousalSupportIncomeAndEarningPotentialSurvey
            newSpousalSupportInfo.incomeInfo = {
                myIncome: incomeEarning.incomeInfo?incomeEarning.incomeInfo:'',
                knowOpIncome: (incomeEarning.knowIncome
                        && incomeEarning.knowIncome == 'y'),
                opIncome: (incomeEarning.knowIncome
                        && incomeEarning.knowIncome == 'y'
                        && incomeEarning.incomeAmount)? incomeEarning.incomeAmount:'',
                knowFacts: (incomeEarning.knowFacts
                        && incomeEarning.knowFacts == 'y'),
                facts: (incomeEarning.knowFacts
                        && incomeEarning.knowFacts == 'y'
                        && incomeEarning.factsExplanation)? incomeEarning.factsExplanation:''                
            }
        }

        if (this.result.aboutSpousalSupportOrderSurvey?.howToPaySpousalSupport){ 
            const aboutSpousalSupport = this.result.aboutSpousalSupportOrderSurvey.howToPaySpousalSupport;           
            newSpousalSupportInfo.payDetails = {
                monthly: aboutSpousalSupport.selected == 'monthly',
                start: (aboutSpousalSupport.selected == 'monthly'
                        && aboutSpousalSupport.monthlyStartDate)?Vue.filter('beautify-date')(aboutSpousalSupport.monthlyStartDate):'',
                end: (aboutSpousalSupport.selected == 'monthly'
                        && aboutSpousalSupport.monthlyEndDate)?Vue.filter('beautify-date')(aboutSpousalSupport.monthlyEndDate):'',
                rate: (aboutSpousalSupport.selected == 'monthly'
                        && aboutSpousalSupport.monthlyAmount)?aboutSpousalSupport.monthlyAmount:'',
                lumpSum: aboutSpousalSupport.selected == 'Lump Sum',
                lumpSumAmount: (aboutSpousalSupport.selected == 'Lump Sum'
                        && aboutSpousalSupport.lumpsumAmount)? aboutSpousalSupport.lumpsumAmount:'',
                other: aboutSpousalSupport.selected == 'other',
                otherComm: (aboutSpousalSupport.selected == 'other' 
                        && aboutSpousalSupport.otherComment)? aboutSpousalSupport.otherComment:''
            }
        }

        if (this.result.calculatingSpousalSupportSurvey){
            newSpousalSupportInfo.calc = {
                attaching: (this.result.calculatingSpousalSupportSurvey.attachingCalculations == 'y'),
                reason: (this.result.calculatingSpousalSupportSurvey.attachingCalculations == 'n'
                        && this.result.calculatingSpousalSupportSurvey.whyNotAttachingCalculations)? this.result.calculatingSpousalSupportSurvey.whyNotAttachingCalculations:''
            }
        }

        let form4unable = false;

        if(this.result.flmAdditionalDocumentsSurvey?.unableFileForms){
            for(const form of this.result.flmAdditionalDocumentsSurvey.unableFileForms){
                if(form.includes("Financial Statement Form 4")){
                    form4unable = true;
                }
            }   
        }

        if(this.result.flmAdditionalDocumentsSurvey?.isFilingAdditionalDocs =='n' && form4unable){
            newSpousalSupportInfo.applyForCaseManagement = true           
        }

        return newSpousalSupportInfo;
    }
}
